module.exports = "https://static.wanderu.com/ui-react/_next/static/media/homescreen-iphone2x.430d3b99.png";